<template>
  <div class="flex items-center justify-between">
    <span v-if="label || description" id="toggleLabel" class="flex-grow flex flex-col">
      <span v-if="label" class="text-sm leading-5 font-medium text-gray-700">{{ label }}</span>
      <span v-if="description" class="text-sm leading-normal text-gray-500">{{ description }}</span>
    </span>
    <span
      role="checkbox"
      tabindex="0"
      aria-checked="false"
      aria-labelledby="toggleLabel"
      :class="[
        textValue ? 'bg-indigo-600' : 'bg-gray-200',
        'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none',
        { 'ml-2': label || description },
      ]"
      @click="toggleInput"
    >
      <span
        aria-hidden="true"
        :class="textValue ? 'translate-x-5' : 'translate-x-0'"
        class="inline-block h-5 w-5 transform rounded-full bg-white transition duration-200 ease-in-out"
      ></span>
    </span>
  </div>
</template>

<script>
export default {
  props: ['modelValue', 'label', 'description', 'placeholder', 'optional', 'disabled'],
  data() {
    return {
      textValue: this.modelValue,
    };
  },
  watch: {
    modelValue(newVal) {
      this.textValue = newVal;
    },
  },
  methods: {
    toggleInput() {
      this.textValue = !this.textValue;
      this.$emit('update:modelValue', this.textValue);
    },
  },
};
</script>
